import NotFound from '../../../base/pages/errorPages/NotFound';

const notFound: NotFound = {
  title: 'Page not found',
  subtitle: 'We all make mistakes, everybody should be given a second-chance.',
  quip: 'Maybe you should try it again but without the socks.'
};

export default notFound;
